import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import useUserStore from 'common/stores/user';
import PermissionManager from './permissions/PermissionManager';

export default function ProtectedRoute({
	children,
	requireUserRole = '',
}: {
	children: React.ReactNode;
	requireUserRole?: string;
}) {
	const {user} = useUserStore();
	const location = useLocation();

	if (!user?.id) return <Navigate to="/login" state={{from: location}} replace />;
	if (requireUserRole) {
		const permissionManager = new PermissionManager(user);
		if (!permissionManager.hasAccess(requireUserRole)) {
			const requiredRoles = permissionManager.getRequiredRoles(requireUserRole);
			return (
				<Navigate
					to="/unauthorized"
					state={{requiredRoles}}
					replace
				/>
			);
		}
	}

	return children;
}